import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, ListItem, Paper, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { groupByField } from '../../utils/ArrayUtility';
import CustomShaped from '../styled/CustomShaped';
import dayjs from 'dayjs';
import { SCROLL_BAR_STYLE_PROPS } from '../../constants/ScrollbarProps';
import { APP_ROUTES } from '../../constants/AppRoutes';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

function ThreadHistory({ history, activeThreadId }: { history: any, activeThreadId?: string }) {

    const groupedHistory = useMemo(
        () => groupByField(history, 'created_at'),
        [history]);

    return (
        <>
            <Accordion defaultExpanded={true}
                TransitionProps={{ timeout: 200 }}
                elevation={0}
                sx={{
                    marginTop: 3,
                    maxHeight: '75vh',
                    background: 'transparent',
                    '& .MuiAccordion-heading .MuiAccordionSummary-root': {
                        marginLeft: '15.5%',
                        lineHeight: 1,
                    },
                    '& .MuiAccordionSummary-contentGutters': {
                        margin: '0 !important',
                    },
                    '&.Mui-expanded .MuiAccordionSummary-root': {
                        borderBottom: '0px !important',
                    }
                }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon htmlColor='var(--text-primary)' />}
                    sx={{
                        display: 'flex',
                        width: 'max-content',
                        padding: 0,
                        borderBottom: '2px solid  black !important',
                        transition: 'margin 100ms ease-in-out'
                    }}
                >
                    <Typography variant='h6' component={'div'}>
                        History
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{
                    boxSizing: 'border-box',
                    paddingY: 1,
                    paddingX: 2,
                }}>
                    <CustomShaped borderSize='short' bgcolor='#03F0FF1A'>
                        <Box sx={{
                            minHeight: '12.5vh',
                            maxHeight: '25vh',
                            overflow: 'scroll',
                            boxSizing: 'border-box',
                            paddingY: 2,
                            overflowX: 'hidden',
                            ...SCROLL_BAR_STYLE_PROPS,
                        }}>

                            {history.length === 0 && <Paper elevation={0} sx={{ padding: 2, background: 'transparent' }}>
                                <Typography>No previous history.</Typography></Paper>}
                            {history.length > 0 && Object.entries(groupedHistory)
                                .map(([day, chat]: [day: string, chat: any], index: number) => {
                                    if (chat.length === 0) return <React.Fragment key={index}></React.Fragment>
                                    return (
                                        <Paper
                                            elevation={0}
                                            key={index}
                                            sx={{
                                                background: 'transparent',
                                                marginBottom: 2,
                                                '&:last-of-type': {
                                                    marginBottom: 0
                                                }
                                            }}>
                                            <Typography variant="subtitle1" marginBottom={1} component={'div'} sx={{
                                                marginLeft: 3,
                                            }}>
                                                {day}
                                            </Typography>
                                            {chat.map((eachChat: any, eIndex: number) => {
                                                return (
                                                    <Box key={eIndex} sx={{
                                                        paddingLeft: 3,
                                                        transition: 'background 200ms ease-in-out',
                                                        background: (activeThreadId === eachChat.thread_id) ? '#00FFF233' : '',
                                                        '&:hover': {
                                                            background: '#00FFF233',
                                                        }
                                                    }}>
                                                        <ListItem
                                                            component={Link}
                                                            to={`${APP_ROUTES.ASK_GUARDIAN}/${encodeURIComponent(eachChat.thread_id)}`}
                                                            replace={true}
                                                            sx={{
                                                                p: 0,
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                rowGap: 0.5,
                                                                alignItems: 'start',
                                                                textWrap: 'balance',
                                                                color: 'var(--text-dark)',
                                                                fontWeight: 400,
                                                                '&:hover': {
                                                                    color: 'var(--text-dark)',
                                                                }
                                                            }}>
                                                            <Typography variant="body1" fontStyle={'italic'} fontSize={'1rem'} lineHeight={1.25}>
                                                                {eachChat.entries.length > 0 && eachChat.entries.filter((s: any) => s.category === "request")[0].data.content.text}
                                                            </Typography>
                                                            <Typography variant='body1' fontSize={'0.85rem'} fontWeight={500}>
                                                                {dayjs.utc(eachChat.created_at).local().format("MMM DD, YYYY | hh:mm A")}
                                                            </Typography>
                                                        </ListItem>
                                                        {eIndex + 1 < chat.length && <Divider sx={{ width: '100%', background: '#3E3E3E', my: 1 }}></Divider>}
                                                    </Box>
                                                )
                                            })}
                                        </Paper>
                                    )
                                })}
                        </Box>
                    </CustomShaped>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default React.memo(ThreadHistory)